import React from "react";
import { GlobalStyle } from "../../communities/constants/global-style";
import ProvideLoggedInUser, {
  LoggedInUserContext,
} from "../../providers/ProvideLoggedInUser";
import ProvideLandingSearch from "../../providers/ProvideLandingSearch";
import AuthOverlay from "../../communities/components/auth-overlay";
import UsernameSetupModal from "../../communities/components/username-setup-modal";

const AuthGatedContent = ({ children }) => {
  const { loading, signedIn, currentUser } = React.use(LoggedInUserContext);
  if (loading) return null;
  return (
    <>
      {!signedIn && <AuthOverlay />}
      {signedIn && currentUser && !currentUser.username && (
        <UsernameSetupModal />
      )}
      {children}
    </>
  );
};

export default function CommunitiesLayout({ children }) {
  return (
    <>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <ProvideLandingSearch>
          <AuthGatedContent>{children}</AuthGatedContent>
        </ProvideLandingSearch>
      </ProvideLoggedInUser>
    </>
  );
}
